import { render } from "./PacienteInfo.vue?vue&type=template&id=2af13766&scoped=true"
import script from "./PacienteInfo.vue?vue&type=script&lang=js"
export * from "./PacienteInfo.vue?vue&type=script&lang=js"

import "./PacienteInfo.vue?vue&type=style&index=0&id=2af13766&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/demo-plus.centrodeglaucoma.com/darmin-plus-modular/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2af13766"]])

export default __exports__